<ng-container *transloco="let t">
  <div class="flex flex-col gap-8">
    <span aria-hidden="true" class="fixed-space-24"></span>
    <h1 class="margin-0-auto">{{ lang === 'en' ? 'Your Profile' : 'ملفك الشخصي' }}</h1>

    <span aria-hidden="true" class="fixed-space-16"></span>

    <section class="user-settings">
      <app-edit-profile-form
        class="form"
        [inDialog]="false"
        [hideCloseButton]="true"></app-edit-profile-form>
    </section>
  </div>
</ng-container>
